/**
 * True when the Variables modal is open — host Esc handlers (doc sheet,
 * mission nav, etc.) should defer so Esc closes only the topmost layer.
 * Match the root node (not only `--open`) so the guard works before the
 * open animation class lands.
 */
export const isVariablesPanelOpen = () =>
  !!document.querySelector('.variables-panel-root');
